import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="time-validation"
export default class extends Controller {
  static targets = ["input"];

  validate() {
    console.log("validate");
    const fieldType = this.inputTarget.dataset.fieldType;
    const value = this.inputTarget.value;

    this.clearErrors();

    if (!this.isValidTime(value)) {
      this.showError("Please enter a valid time");
      return false;
    }

    // For end_time, compare with start_time if on same date
    if (fieldType === "end_time") {
      const startTimeInput = document.querySelector(
        '[data-field-type="start_time"]'
      );
      const startDateInput = document.querySelector(
        '[data-field-type="start_date"]'
      );
      const endDateInput = document.querySelector(
        '[data-field-type="end_date"]'
      );

      if (startTimeInput && startTimeInput.value) {
        // Only validate times if dates are the same or no dates are set
        if (
          !startDateInput ||
          !endDateInput ||
          startDateInput.value === endDateInput.value
        ) {
          if (
            this.convertTo24Hour(value) <=
            this.convertTo24Hour(startTimeInput.value)
          ) {
            this.showError("End time must be later than start time");
            return false;
          }
        }
      }
    }

    return true;
  }

  isValidTime(timeStr) {
    const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s*(AM|PM)$/i;
    return timeRegex.test(timeStr);
  }

  convertTo24Hour(timeStr) {
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    hours = parseInt(hours);

    if (period.toUpperCase() === "PM" && hours !== 12) {
      hours += 12;
    } else if (period.toUpperCase() === "AM" && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  }

  showError(message) {
    const errorDiv = document.createElement("div");
    errorDiv.classList.add("invalid-feedback", "d-block");
    errorDiv.textContent = message;
    this.inputTarget.classList.add("is-invalid");
    this.inputTarget.parentNode.appendChild(errorDiv);
  }

  clearErrors() {
    const errorMessages = this.element.querySelectorAll(".invalid-feedback");
    errorMessages.forEach((el) => el.remove());
    this.inputTarget.classList.remove("is-invalid");
  }
}
